export const rightsRequestsTour = {
    module: 'rights_requests',
    title: 'Rights Requests Tour',
    title_vi: 'Tour Yêu cầu quyền',
    description: 'As the Enterprise DPO (P-VN-01), manage data subject rights requests under PDPL with 15-day statutory deadlines, identity verification, and audit-grade resolution trails.',
    description_vi: "Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO (P-VN-01), manage data subject rights requests under PDPL with 15-day statutory deadlines, identity verification, and audit-grade resolution trails.',",
    estimated_duration_seconds: 48,
    steps: [
        {
            step_id: 'open_rights_requests',
            navigate_to: '/admin/rights-requests',
            target: '.ticket-list-page',
            title: 'DSR Intake & Resolution',
            title_vi: 'Tiếp nhận và xử lý DSR',
            description: 'As the Enterprise DPO, you manage all data subject rights requests here. PDPL grants Vietnamese citizens rights to access, delete, correct, and port their personal data with a 15-day response deadline.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the Enterprise DPO, you manage all data subject rights requests here. PDPL grants Vietnamese citizens rights to access, delete, correct, and port their personal data with a 15-day response deadline.',
            position: 'bottom',
            delay_ms: 600,
        },
        {
            step_id: 'requests_list',
            target: '.ticket-table',
            title: 'Request List',
            title_vi: 'Danh sách yêu cầu',
            description: 'All DSRs with their PDPL deadline countdown, request type, verification status, and assigned handler. SLA-breached requests surface in red for immediate DPO escalation.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: All DSRs with their PDPL deadline countdown, request type, verification status, and assigned handler. SLA-breached requests surface in red for immediate DPO escalation.',
            position: 'bottom',
        },
        {
            step_id: 'filter_requests',
            target: '.filters',
            title: 'Filter Requests',
            title_vi: 'Lọc yêu cầu',
            description: 'Filter by status, request type, or date range to prioritize SLA-critical requests and identify patterns across request categories.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Filter by status, request type, or date range to prioritize SLA-critical requests and identify patterns across request categories.',
            position: 'bottom',
        },
        {
            step_id: 'click_create',
            target: '.page-header button',
            title: 'Create New Request',
            title_vi: 'Tạo yêu cầu mới',
            description: 'As the DPO, you may manually register a DSR received via email, phone, or in-person. The 15-day PDPL clock starts from the date of receipt.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: As the DPO, you may manually register a DSR received via email, phone, or in-person. The 15-day PDPL clock starts from the date of receipt.',
            position: 'bottom',
            action: { type: 'click', target: '.page-header button' },
            duration_ms: 100,
        },
        {
            step_id: 'rights_requests_template_picker',
            target: '.dm-modal .template-picker',
            wait_for: '.template-picker',
            title: 'Choose a Template',
            title_vi: 'Chọn mẫu',
            description: 'The template picker lets you start from a pre-built DSR template or create a blank request. Templates pre-fill fields based on common PDPL request scenarios.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: The template picker lets you start from a pre-built DSR template or create a blank request. Templates pre-fill fields based on common PDPL request scenarios.',
            position: 'bottom',
            delay_ms: 500,
        },
        {
            step_id: 'rights_requests_select_template',
            target: '.template-picker-blank',
            title: 'Start from Blank',
            title_vi: 'Bắt đầu từ trang trắng',
            description: 'Select the blank template to create a request from scratch with full control over all fields.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Select the blank template to create a request from scratch with full control over all fields.',
            position: 'bottom',
            action: { type: 'click', target: '.template-picker-blank' },
            delay_ms: 300,
        },
        {
            step_id: 'fill_request_type',
            target: '#request_type',
            title: 'Select Request Type',
            title_vi: 'Chọn loại yêu cầu',
            description: 'Map the request to its PDPL right category: Access/DSAR, Deletion, Correction, Portability, Objection, or Restriction. Each type has distinct fulfillment procedures and evidence requirements.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Map the request to its PDPL right category: Access/DSAR, Deletion, Correction, Portability, Objection, or Restriction. Each type has distinct fulfillment procedures and evidence requirements.',
            wait_for: '.create-case-page',
            position: 'bottom',
            action: { type: 'select', target: '#request_type', value: 'deletion' },
        },
        {
            step_id: 'fill_subject_name',
            target: '#requester_name',
            title: 'Enter Subject Name',
            title_vi: 'Nhập tên chủ thể',
            description: 'Record the data subject identity. PDPL requires identity verification before fulfillment to prevent unauthorized disclosure.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Record the data subject identity. PDPL requires identity verification before fulfillment to prevent unauthorized disclosure.',
            position: 'bottom',
            action: { type: 'fill', target: '#requester_name', value: '[TOUR] Jane Doe' },
        },
        {
            step_id: 'fill_requester_email',
            target: '#requester_email',
            title: 'Enter Email Address',
            title_vi: 'Nhập địa chỉ email',
            description: 'The contact email for sending acknowledgment, progress updates, and final resolution within the 15-day PDPL window.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: The contact email for sending acknowledgment, progress updates, and final resolution within the 15-day PDPL window.',
            position: 'bottom',
            action: { type: 'fill', target: '#requester_email', value: 'jane.doe@example.com' },
        },
        {
            step_id: 'fill_description',
            target: '#description',
            title: 'Add Description',
            title_vi: 'Thêm mô tả',
            description: 'Document the request scope and any supporting context. This narrative becomes part of the audit trail for regulatory inspections.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Document the request scope and any supporting context. This narrative becomes part of the audit trail for regulatory inspections.',
            position: 'bottom',
            action: {
                type: 'fill',
                target: '#description',
                value: '[TOUR] Request to delete all personal data per GDPR Art. 17',
            },
        },
        {
            step_id: 'submit_request',
            target: '.create-case-form button[type="submit"]',
            title: 'Submit the Request',
            title_vi: 'Gửi yêu cầu',
            description: 'Submitting starts the PDPL 15-day countdown. The request enters the queue with a pending status and an auto-calculated deadline.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Submitting starts the PDPL 15-day countdown. The request enters the queue with a pending status and an auto-calculated deadline.',
            position: 'top',
        },
        {
            step_id: 'view_detail',
            navigate_to: '/admin/rights-requests',
            target: '.ticket-table tbody tr:first-child',
            title: 'View Request Detail',
            title_vi: 'Xem chi tiết yêu cầu',
            description: 'Open any DSR to see the full processing timeline, assigned handler, verification status, and available compliance actions.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open any DSR to see the full processing timeline, assigned handler, verification status, and available compliance actions.',
            position: 'bottom',
            wait_for: '.ticket-table',
            action: { type: 'click', target: '.ticket-table tbody tr:first-child' },
        },
        {
            step_id: 'update_status',
            scroll_to: true,
            target: '.status-actions button',
            title: 'Update Request Status',
            title_vi: 'Cập nhật trạng thái yêu cầu',
            description: 'Advance the DSR through its lifecycle. Each status change is timestamped in the audit trail, documenting compliance with PDPL response obligations.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Advance the DSR through its lifecycle. Each status change is timestamped in the audit trail, documenting compliance with PDPL response obligations.',
            position: 'top',
            wait_for: '.status-actions button',
        },
        {
            step_id: 'open_audit_tab',
            scroll_to: true,
            target: '.tab-nav button:nth-child(5)',
            title: 'Audit Trail Tab',
            title_vi: 'Tab Nhật ký kiểm toán',
            description: 'Open the immutable audit trail that documents every action taken on this DSR, forming the evidence package for PDP Committee inspections.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Open the immutable audit trail that documents every action taken on this DSR, forming the evidence package for PDP Committee inspections.',
            position: 'bottom',
            action: { type: 'click', target: '.tab-nav button:nth-child(5)' },
        },
        {
            scroll_to: true,
            step_id: 'request_timeline',
            target: '.audit-list',
            title: 'Request Timeline',
            title_vi: 'Dòng thời gian yêu cầu',
            description: 'Every action is logged with actor, timestamp, and outcome. This produces an audit-grade dossier proving timely PDPL compliance with contributor lineage.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: Every action is logged with actor, timestamp, and outcome. This produces an audit-grade dossier proving timely PDPL compliance with contributor lineage.',
            position: 'right',
            wait_for: '.audit-list',
        },
        {
            step_id: 'rights_requests_complete',
            target: '.ticket-list-page',
            title: 'Rights Requests Tour Complete',
            title_vi: 'Hoàn thành tour Yêu cầu quyền',
            description: 'You can now manage the full DSR lifecycle under PDPL: intake, identity verification, 15-day deadline tracking, resolution, and audit-grade evidence export.',
            description_vi: 'Bản dịch tiếng Việt sẽ được chuẩn hoá ở Sprint 44.1.8. Nội dung tiếng Anh: You can now manage the full DSR lifecycle under PDPL: intake, identity verification, 15-day deadline tracking, resolution, and audit-grade evidence export.',
            position: 'bottom',
        },
    ],
};
//# sourceMappingURL=rights-requests.js.map